export default "/images/vendor/flag-icons/flags/1x1/dj.svg?843e714eaf72c7dfbf0dbed54563e05c";